<template>
  <div class="ring" :style="{ width: size + 'px', height: size + 'px' }">
    <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
      <circle class="ring-bg" :cx="size / 2" :cy="size / 2" :r="radius" :stroke-width="stroke" fill="none" />
      <circle
        class="ring-fg"
        :cx="size / 2"
        :cy="size / 2"
        :r="radius"
        :stroke="color"
        :stroke-width="stroke"
        fill="none"
        stroke-linecap="round"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="offset"
      />
    </svg>
    <div class="ring-label">
      <slot>{{ Math.round(percent) }}%</slot>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'

const props = defineProps({
  percent: { type: Number, default: 0 },
  size: { type: Number, default: 120 },
  stroke: { type: Number, default: 10 },
  color: { type: String, default: '#22c55e' },
})

const mounted = ref(false)
onMounted(() => requestAnimationFrame(() => { mounted.value = true }))

const radius = computed(() => (props.size - props.stroke) / 2)
const circumference = computed(() => 2 * Math.PI * radius.value)
const offset = computed(() => {
  const pct = mounted.value ? Math.max(0, Math.min(100, props.percent)) : 0
  return circumference.value * (1 - pct / 100)
})
</script>

<style scoped>
.ring { position: relative; display: inline-block; }
.ring svg { transform: rotate(-90deg); }
.ring-bg { stroke: rgba(148, 163, 184, 0.25); }
.ring-fg { transition: stroke-dashoffset 1.4s cubic-bezier(0.22, 1, 0.36, 1); }
.ring-label {
  position: absolute; inset: 0; display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: 1.1rem; color: #1e293b; text-align: center;
}
</style>
